// Recovered compiled webpack factory 27290. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { X: () => s, f: () => n });
  let n = (t) => 1e3 * t,
    s = (t) => t / 1e3;
}
